// extracted by mini-css-extract-plugin
module.exports = {"container":"playerNewsHeader_container__g14PW","header":"playerNewsHeader_header__elUwV","link":"playerNewsHeader_link__7xq7n"};